import React from "react";

class IntroSubsection extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="Introsubsection">
        <div className="column">
          <div className="internal">
            <p dangerouslySetInnerHTML={{ __html: this.props.introSubsectionText.replace(/\n/g,"<br />") }}></p>
          </div>
        </div>
        <div className="column">
          <div className="internal">
            <div className="intro-testimonial">
              <div className="profile">
                <img className="profile__image" src={this.props.introTestimonialPhoto.url} title={this.props.introTestimonialPhoto.title} alt={this.props.introTestimonialPhoto.alt} />
                <div className="profile__container">
                  <span className="name">{this.props.introTestimonialName}</span>
                  <span className="quote">{this.props.introTestimonialQuote}</span>
                </div>
              </div>
              <div className="text">
                <p dangerouslySetInnerHTML={{ __html: this.props.introTestimonialText.replace(/\n/g,"<br />") }}></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default IntroSubsection;


// WEBPACK FOOTER //
// ./src/home/intro-subsection.js